import { Env } from '@env';
import Constants from 'expo-constants';
import mixpanelBrowser from 'mixpanel-browser';
import { UnistylesRuntime } from 'react-native-unistyles';

class MixpanelService {
  mixpanel = null;

  constructor() {
    if (Env.APP_ENV !== 'development') {
      mixpanelBrowser.init(Env.MIXPANEL_PROJECT_TOKEN, {
        api_host: 'https://mp.eonrides.com',
        ignore_dnt: true,
        record_sessions_percent: 100,
        record_heatmap_data: true,
        record_mask_text_selector: '',
        record_mask_text_class: '',
        record_block_class: '',
        record_block_selector: '',
        record_canvas: true,
        record_inline_images: true,
        record_collect_fonts: true,
      });

      this.mixpanel = mixpanelBrowser;

      let platform = '';
      let referrer = '';
      let referrerDomain = '';
      if (document.referrer) {
        const referrerUrl = new URL(document.referrer);

        referrer = document.referrer;
        referrerDomain = referrerUrl.hostname;
      }

      if (['xs', 'sm'].includes(UnistylesRuntime.breakpoint)) {
        platform = 'mobile';
      } else {
        platform = 'desktop';
      }

      this.mixpanel.register({
        'App Version': Constants.expoConfig?.version,
        'Device Type': platform,
        Referrer: referrer,
        'Referrer Domain': referrerDomain,
      });
    }
  }

  initSessionReplay(_email?: string) {
    return; // Not needed for web
  }

  register(attrs: {}) {
    if (!this.mixpanel) return;

    this.mixpanel.register(attrs);
  }

  // Cross-domain identity stitch. `mpId` is website A's anonymous device id
  // ($device_id without the "$device:" prefix). On web the device id is a
  // persisted super property, so a plain register() overwrites it; events then
  // merge into A's anonymous profile under Mixpanel's simplified ID merge.
  stitchDeviceId(mpId: string) {
    if (!this.mixpanel) return;

    this.mixpanel.register({
      $device_id: mpId,
      distinct_id: `$device:${mpId}`,
    });
  }

  getProperty(prop: string) {
    if (!this.mixpanel) return {};

    return this.mixpanel.get_property(prop);
  }

  track(event: string, props = {}) {
    if (!this.mixpanel) return;

    this.mixpanel.track(event, props);
  }

  flush() {
    return; // mixpanel-browser flushes automatically on tab close/hide
  }

  identify(userId: string) {
    if (!this.mixpanel) return;

    this.mixpanel.identify(userId);
  }

  setPeople(attrs: {}) {
    if (!this.mixpanel) return;

    this.mixpanel.people.set(attrs);
  }
}

const mixpanelService = new MixpanelService();
export default mixpanelService;
